import { Controller } from "@hotwired/stimulus"

// Turbo snapshots the live DOM, including vote flags, celebration nodes,
// and toasts stamped into the turbo-permanent toaster. Strip those before
// cache so a back-navigation preview cannot replay them.
export default class extends Controller {
  connect() {
    this.boundBeforeCache = () => this.beforeCache()
    document.addEventListener("turbo:before-cache", this.boundBeforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.boundBeforeCache)
  }

  beforeCache() {
    document.querySelectorAll("[data-vote-pill-just-voted-value='true']").forEach((el) => {
      el.setAttribute("data-vote-pill-just-voted-value", "false")
    })
    document.getElementById("poetry-toaster")?.replaceChildren()
    document.getElementById("flash-toasts")?.remove()
    document.querySelectorAll(".mascot-celebrate-burst, canvas.vote-confetti").forEach((el) => el.remove())
  }
}
